import React from 'react';
import './LoadingOverlay.css';

type LoadingOverlayProps = {
  loading: boolean;
  message?: string;
  className?: string; // optional extra classes for the outer container
  children: React.ReactNode;
};

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
                                                                loading,
                                                                message = 'Loading…',
                                                                className = '',
                                                                children,
                                                              }) => {
  return (
    <div className={`overlay-container ${className}`} aria-busy={loading}>
      {children}
      {loading && (
        <div
          className="loading-overlay"
          role="status"
          aria-live="polite"
          aria-label={message}
        >
          <div className="loading-panel">
            <div className="spinner" aria-hidden="true"/>
            <span className="loading-text">{message}</span>
          </div>
        </div>
      )}
    </div>
  );
};
